import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ItemPage } from '../pages/item/item';
import { XabPage } from '../pages/xab/xab';
import { DistractorPage } from '../pages/distractor/distractor';
import { LoginPage } from '../pages/login/login';
import { ParticipantPage } from '../pages/participant/participant';
import { ThankYouPage } from '../pages/thankyou/thankyou';
import { SmartAudio } from '../providers/smart-audio';
import { CPS } from '../providers/cps';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ItemPage,
    XabPage,
    LoginPage,
    ParticipantPage,
    DistractorPage,
    ThankYouPage
  ],
  imports: [
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ItemPage,
    XabPage,
    ThankYouPage
  ],
  providers: [{provide: ErrorHandler, useClass: IonicErrorHandler},SmartAudio,CPS]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts